<template>
  <a-card :bordered='false' style='width: 100%' v-if='checkResult'>
    <SignFileShow v-if="xstatus.isShowPassBidder === '1' && !pdfCententShow" :sectionId='sectionId'
                  :type='pdfParams.type'></SignFileShow>
    <div style='margin:10px 0;display: inline-block' v-if="xstatus.isShowPassBidder !== '1'">
      <a-space>
<!--
        <a-button v-if="xstatus.isShowPassBidder !== '1' && !pdfCententShow && isEdit" type='primary' @click='startCheck()'>发起确认</a-button>
-->
        <a-button v-if="xstatus.isShowPassBidder !== '1' && pdfCententShow" htmlType='button'
                  @click='saveSignFile' :loading='loading' type='primary'>保存签章文件
        </a-button>
        <SignatureButton
          v-show='!pdfCententShow'
          ref='SignatureButton'
          :pdf-params='pdfParams'
          :stampShowed='pdfCententShow'
          :disabled="xstatus.isShowPassBidder === '1'"
          @sign='sign'
          @signShow='signShow'
        ></SignatureButton>
      </a-space>
    </div>
    <a-space direction='vertical' style='width: 100%' v-show='!pdfCententShow' id='pdfCentent' v-if="xstatus.isShowPassBidder !== '1'">
      <a-row>
        <a-col :span='24'>
          <a-table
            ref='table'
            bordered
            size='middle'
            :columns='columns'
            :dataSource='candidates'
            :loading='loading'
            :pagination='false'>
            <template slot="title" slot-scope="currentPageData">
              <a-row>
                <a-col :span='24' style='width: 100%;text-align: center;font-size: 24px;font-weight: bold;'>
                  <span>第一信封结果</span>
                </a-col>
              </a-row>
            </template>
          </a-table>
        </a-col>
      </a-row>
    </a-space>

    <SignatureComponent
      v-show='pdfCententShow'
      ref='stamp'
      :pdf-params='pdfParams'
      @checkStampForm='checkStampForm'
      @changeIsStamp='changeIsStamp'
    ></SignatureComponent>
    <SignFileShow-modal ref='modalForm'></SignFileShow-modal>
    <a-modal v-model='visible' title='确认时长' @ok="checkTimer">
      <a-row :gutter='[0,24]'>
        <a-col :span='24'>
          投标人确认时长(分钟)：
          <a-input-number v-model='time' :min="1" :max="100"  :step="1" :precision="0"/>
        </a-col>
      </a-row>
    </a-modal>
  </a-card>
</template>

<script>
import { FzisListMixin } from '@/mixins/FzisListMixin'
import { downloadFile, getAction, postAction } from '@api/manage'
import SignFileShow from '@views/bobidopen/modules/SignFileShow.vue'
import SignatureButton from '@comp/SignatureButton'
import numeral from 'numeral'
import SignFileShowModal from '@views/bobidopen/modules/SignFileShowModal.vue'
import SignatureComponent from '@comp/SignatureComponent'
import { StatusMixin } from '@/mixins/StatusMixin'

export default {
  name: 'ManualBenchmarkCompute',
  components: { SignatureComponent, SignFileShowModal, SignatureButton, SignFileShow },
  mixins: [StatusMixin],
  data() {
    return {
      sectionId: '',
      bidProjectId: '',
      url: {},
      candidates: [],
      columns: [
        {
          title: '序号（非排名）',
          dataIndex: '',
          key: 'rowIndex',
          width: 200,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '企业名称',
          dataIndex: 'bidderName',
        },
        {
          title: '评审结果',
          dataIndex: 'isPass',
          customRender: function(t, r, index) {
            return '通过'
          }
        },
      ],
      oriColumns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '企业名称',
          dataIndex: 'bidderName',
          customRender: function(t, r, index) {
            let name=t;
            if (r.unionEnterpriseName){
              name= name+"(联合体成员：" + r.unionEnterpriseName + ")"
            }
            if(r.subpackageName)
            {
              name=name+" (分包企业：" + r.subpackageName + ")"
            }
            return name;
          }
        },
        {
          title: '统一社会信用代码',
          dataIndex: 'bidderOrgCode',
        },
        {
          title: '投标报价(元)',
          dataIndex: 'bidPrice',
          customRender: function(t, r, index) {
            return numeral(r.bidPrice).format('0,0.00')
          }
        },
      ],
      data: [],
      initData: {},
      bidderColumns: [
        {
          title: '序号',
          width: 80,
          dataIndex: '',
          key: 'rowIndex',
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '企业名称',
          align: 'center',
          dataIndex: 'bidderName',
          width: 170,
          scopedSlots: { customRender: 'bidderName' },
        },
        {
          title: '投标报价（元）',
          align: 'center',
          dataIndex: 'bidPrice',
          width: 230,
          customRender: function(t, r, index) {
            return numeral(r.bidPrice).format('0,0.00')
          }
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          className:'noPrint',
          width: 150
        },
      ],
      loading: false,
      visible: false,
      time: null,
      //以下签章-----------
      isNeedStamp: true,
      isStamp: true,
      pdfCententShow: false,
      pdfParams: {
        pageId: '',
        signedPdfUrl: '',
        bidProjectId: '',
        sectionId: '',
        type: 'FirstLetterPassBidderStamp',
        typeZh: '第一信封通过企业签章',
        htmlTitle: '第一信封通过企业签章',
        fp: '4',
        signType: '1'//1:统一CA，2：工改签章
      },
      signDisabled: false,
      isEdit:true,
    }
  },
  props: ['checkId'],
  computed: {
  },
  methods: {
    async setBidProjectId(tenderId, sectionId) {
      let that = this
      this.xstatus.isShowPassBidder = '0';
      this.$nextTick(async () => {
        //1.根据招标编号ID获取招标项目信息和项目信息
        this.bidProjectId = tenderId
        this.sectionId = sectionId
        this.pdfParams.bidProjectId = tenderId
        this.pdfParams.sectionId = sectionId
        this.pdfParams.pageId = this.sectionId + '_FirstOpenTable_' + new Date().getTime()
        await this.queryStatus()
        getAction('/ebid-ce/boCandidate/getFirstCandidate/' + this.sectionId, {}).then(res => {
          if (res.success) {
            that.candidates = res.result;
            for (let i = 0; i < that.candidates.length; i++) {
              that.initData[that.candidates[i].bidderName] = that.candidates[i];
            }
          } else {
          }
        })
      })
    },
    startCheck() {
      this.visible = true;
      this.$nextTick(() => {
        this.pdfCententShow = true
        this.$refs.stamp.viewStamp()
      });
    },
    checkTimer() {
      let that = this;
      if(that.pdfParams.signedPdfUrl==null)
      {
        that.$message.error('请等待页面加载完再进行操作！')
        return;
      }
      this.$confirm({
        title: '提示',
        content: '是否立即发送投标人确认？',
        onOk() {
          let params = {}
          params.sectionId = that.sectionId
          params.pdfUrl = that.pdfParams.signedPdfUrl
          params.timeDuration = that.time
          params.menuId = that.checkId
          postAction('/ebid-ce/tmBidderCheck/add', params).then(res => {
            if (res.success) {
              that.visible = false;
              that.$message.success("等待投标企业确认内容");
            } else {
              that.$message.error(res.message)
            }
          }).catch(() => {
            that.$message.error('操作失败，请重试！')
          }).finally(() => {
            that.loading = false
          })
        }
      });
    },
    //-----------以下为签章--------------------
    sign(type) {

      this.pdfCententShow = true;
      let that=this;
      this.$nextTick(() => {
        that.pdfParams.signType = type
        that.$refs.stamp.checkStamp()
      })
    },
    //签章文件查看
    signShow() {
      this.$refs.modalForm.show(this.sectionId, this.pdfParams.type)
    },
    //重新编辑
    reEdit() {
      this.pdfParams.pageId = ''
      this.pdfParams.signedPdfUrl = ''
      this.pdfCententShow = false
      this.$refs.stamp.pdfUrl = null
    },
    changeIsStamp(val) {
      this.pdfCententShow = val
    },
    checkStampForm(callback) {
      callback(true)
    },
    saveSignFile() {
      let that = this
      if (this.$refs.stamp.getPdfUrl() == null) {
        this.$message.info('请先获取签章文件后再进行保存提交！')
        return
      }
      let params = {}
      params.pdfUrl = that.$refs.stamp.getPdfUrl()
      params.type = that.pdfParams.type
      params.typeZh = that.pdfParams.typeZh
      params.bidProjectId = that.pdfParams.bidProjectId
      // params.checkId = that.checkId
      params.key = "isShowPassBidder"
      postAction('/ebid-ce/boOpenStatus/saveOpenStatusSignFile/' + that.sectionId, params).then(res => {
        if (res.success) {
          that.xstatus.isShowPassBidder = '1'
        } else {
          that.$message.error(res.message)
        }
      }).catch(() => {
        that.$message.error('操作失败，请重试！')
      }).finally(() => {
        that.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>